module.exports = "<div class=share-screen__contents> <div class=share-screen__image-container> <img ng-src={{$ctrl.imageurl}} alt=\"\"/> </div> <a class=call-to-action-button href={{$ctrl.AppServices.DataManager.langContent.SHARING_URL.value}} target=_parent>{{$ctrl.AppServices.DataManager.langContent.SHARE_URL_CTA.value}}</a> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/share-screen/share-screen.html
 ** module id = 87
 ** module chunks = 0
 **/